/**
 * Listing photo display helpers for public cards and detail views.
 * Avoid stock/Unsplash fallbacks when owners have not uploaded photos yet.
 */

export const LISTING_PHOTO_PENDING_TEST_ID = 'listing-photo-pending';

function normalizePhotoUrl(photo) {
  if (!photo) return null;
  if (typeof photo === 'string') return photo.trim() || null;
  const url = photo.url;
  return typeof url === 'string' && url.trim() ? url.trim() : null;
}

export function listingHasUploadedPhotos(listing) {
  return resolveListingPhotoUrls(listing).length > 0;
}

export function resolveListingPhotoUrls(listing) {
  const photos = listing?.photos || [];
  if (photos.length > 0) {
    return photos.map(normalizePhotoUrl).filter(Boolean);
  }
  const hero = listing?.hero_photo_url;
  return typeof hero === 'string' && hero.trim() ? [hero.trim()] : [];
}

export function resolveListingPhotoEntries(listing) {
  const photos = listing?.photos || [];
  if (photos.length > 0) {
    return photos
      .map((photo) => {
        if (typeof photo === 'string') {
          const url = normalizePhotoUrl(photo);
          return url ? { url, category: 'HERO' } : null;
        }
        const url = normalizePhotoUrl(photo);
        return url ? { ...photo, url } : null;
      })
      .filter(Boolean);
  }
  const hero = listing?.hero_photo_url;
  if (typeof hero === 'string' && hero.trim()) {
    return [{ url: hero.trim(), category: 'HERO' }];
  }
  return [];
}
